import Ul from '../elements/Ul';
import DataMenu from '../data/DataMenu';
import '../css/components/Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-middle">
          <Ul
            ulClassName="ul-navbar-header"
            liClassName="li-navbar-header"
            liValues={ DataMenu }
          />
      </div>
    </header>
  );
}

export default Header;
